/**
 * Which yards host ambient frogs, and where each frog lives.
 *
 * Hubert and Holly Springs only — two frogs per yard, each with its own home
 * patch and roam radius. Spanish Fork has none.
 */

import type { FrogYardConfig } from '@/world-prototype/creatures/frogBehavior';

/**
 * Hubert — grassy mid-yard patches away from the patio, fire pit, and nest.
 * Roam polygons reuse the rabbit's interior grass (fence-safe).
 */
const HUBERT_FROG: FrogYardConfig = {
  yardId: 'hubert',
  roamPolygon: [
    { x: 0.42, y: 0.46 },
    { x: 0.7, y: 0.46 },
    { x: 0.8, y: 0.56 },
    { x: 0.88, y: 0.66 },
    { x: 0.92, y: 0.75 },
    { x: 0.92, y: 0.82 },
    { x: 0.11, y: 0.82 },
    { x: 0.11, y: 0.72 },
    { x: 0.19, y: 0.64 },
    { x: 0.3, y: 0.54 },
  ],
  frogs: [
    {
      id: 'hubert-frog-left',
      home: { x: 0.34, y: 0.63 },
      roamRadius: 0.055,
      idlePhase: 0.15,
    },
    {
      id: 'hubert-frog-right',
      home: { x: 0.71, y: 0.67 },
      roamRadius: 0.05,
      idlePhase: 0.72,
    },
  ],
};

/**
 * Holly Springs — open lawn, away from the swingset and big tree base.
 */
const HOLLY_SPRINGS_FROG: FrogYardConfig = {
  yardId: 'raleigh',
  roamPolygon: [
    { x: 0.33, y: 0.45 },
    { x: 0.7, y: 0.45 },
    { x: 0.86, y: 0.6 },
    { x: 0.86, y: 0.79 },
    { x: 0.24, y: 0.79 },
    { x: 0.24, y: 0.6 },
  ],
  frogs: [
    {
      id: 'holly-springs-frog-near',
      home: { x: 0.44, y: 0.62 },
      roamRadius: 0.052,
      idlePhase: 0.28,
    },
    {
      id: 'holly-springs-frog-far',
      home: { x: 0.66, y: 0.71 },
      roamRadius: 0.048,
      idlePhase: 0.81,
    },
  ],
};

const FROG_YARDS: Readonly<Record<string, FrogYardConfig>> = {
  hubert: HUBERT_FROG,
  raleigh: HOLLY_SPRINGS_FROG,
};

export function frogConfigForYard(
  yardId: string | null | undefined,
): FrogYardConfig | null {
  if (!yardId) return null;
  return FROG_YARDS[yardId] ?? null;
}

export function frogYardIds(): readonly string[] {
  return Object.keys(FROG_YARDS);
}
